import React from 'react';
import PropTypes from 'prop-types';
import MuiSnackbar from '@material-ui/core/Snackbar';
import { withStyles } from '@material-ui/core/styles';

import { CHILDREN_PROPTYPES } from 'base/constants/propTypes';

const styles = theme => ({
  root: {
    position: 'absolute',
    [theme.breakpoints.up('sm')]: {
      top: ({
        isAsapAvailableForPickup,
        isAsapAvailableForDelivery,
        availableFulfillmentOptions
      }) =>
        !isAsapAvailableForPickup &&
        !isAsapAvailableForDelivery &&
        availableFulfillmentOptions.length === 2
          ? '-115px'
          : '-100px',
      '& .$MuiSnackbarContent-root': {
        backgroundColor: theme.palette.secondary.main,
        width: '396px',
        borderRadius: '8px',
        paddingLeft: '18px'
      }
    },
    [theme.breakpoints.down('sm')]: {
      position: 'inherit',
      bottom: 'auto',
      margin: '5px 20px 0',
      '& .$MuiSnackbarContent-root': {
        backgroundColor: theme.palette.secondary.main,
        width: '396px',
        borderRadius: '4px',
        paddingLeft: '18px'
      }
    }
  }
});

const AlertSnackbar = ({
  open,
  message,
  onClose,
  classes,
  horizontal,
  vertical
}) => {
  return (
    <MuiSnackbar
      open={open}
      onClose={onClose}
      classes={classes}
      message={message}
      anchorOrigin={{
        horizontal: horizontal,
        vertical: vertical
      }}
    />
  );
};

AlertSnackbar.defaultProps = {
  open: false,
  onClose: () => {},
  horizontal: 'center',
  vertical: 'top'
};

AlertSnackbar.propTypes = {
  open: PropTypes.bool,
  classes: PropTypes.shape({}).isRequired,
  onClose: PropTypes.func,
  message: CHILDREN_PROPTYPES.isRequired,
  horizontal: PropTypes.string,
  vertical: PropTypes.string
};

export default withStyles(styles)(AlertSnackbar);
